export const ADD_PERIMETER = 'ADD_PERIMETER'
export const ADD_PERIMETERS = 'ADD_PERIMETERS'
export const LOAD_PERIMETER = 'LOAD_PERIMETER'
export const LOAD_PERIMETERS = 'LOAD_PERIMETERS'
export const DELETE_TABLE_FROM_PERIMETER = 'DELETE_TABLE_FROM_PERIMETER'
export const DELETE_PERIMETER = 'DELETE_PERIMETER'
export const ADD_TABLES_TO_PERIMETER = 'ADD_TABLES_TO_PERIMETER'